import React from 'react';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { highlightQuery } from 'site-modules/shared/utils/inventory/global-search-links';
import PropTypes from 'prop-types';

export const LinkTitle = ({ query = '', title = '' }) => {
  return (
    <span className="fw-bold d-block">
      <ContentFragment componentToUse="span">{highlightQuery({ userInput: query, title })}</ContentFragment>
    </span>
  );
};

LinkTitle.propTypes = {
  query: PropTypes.string,
  title: PropTypes.string,
};
